import StepHeader from 'components/flow/step-header/step-header.component';
import styled from 'styled-components';

export const CustomStepHeader = styled(StepHeader)`
  margin-top: 0;
`;
